<template>
	<div class="bottomMsView" style="position: relative;">
		<div @click='moreEvent' :style='island?"background-color:rgba(244, 244, 244, 1);padding: .5rem;z-index:101":"padding: .5rem"'>
			<a-badge :count="params.missionNum"
				:numberStyle="{width:'0.8rem',height:'0.8rem',minWidth:'0.8rem',lineHeight:'0.8rem',padding:'0',fontSize:'0.5rem',top:'0.3rem'}">
				<img :src="params.mission_flag==1 ? icon_renwu1 : icon_renwu" style="width:2rem;height:2rem;">
			</a-badge>
			<span class='renwufont'>任務</span>
		</div>
		<div v-show='island' id='MsViewid'>
			<div class='awrptitle'>
				<div class='hovercolor' style='display:inline-block'>
					<a-icon type="left" @click="searchEvent" v-if='params.mission_flag==1' />
					<span v-else style='display:inline-block;width:15px;height:15px'> </span>
					<span @click="searchEvent" style='color:#000'>任務</span>
				</div>
				<a-icon type="reload" style='float:right;margin-right:14px' @click='getdata' class='hovercolor' />
			</div>
			<div style="padding: 0 10px;background-color: #fff;">
				<div>
					<div class='gre-title' @click='static = !static'>
						審批
						<a-icon type="down" class='icon-right hovercolor' :class='static?"icon-right0":"icon-right1"' />
					</div>
					<div :style="{height: static?'0px':2*listdata.length+'rem'}" class="warp_top">
						<div v-for='(item,ind) in listdata' :key="ind" class='wil-list warp_listjqy' @click="handleClick(item,ind)" :style='{color:staticadmin == ind?"#8763ee":""}'>
							{{item.status}}
							<a-badge :count="item.counts" :numberStyle="{width:'0.8rem',height:'0.8rem',minWidth:'0.8rem',lineHeight:'0.8rem',padding:'0',fontSize:'0.5rem',top: '-0.1rem',left: '.2rem'}">
							</a-badge>
							<span v-if='item.counts>99' style="position: relative;top: -8px;left: -4px;"> +</span>
							<a-icon type="right" style='position: absolute;top: 0.8rem;right: .6rem;margin: 0;font-size: 10px;' />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- </a-popover> -->
</template>

<script>
	import icon_renwu from '@/image/icon_renwu.png';
	import icon_renwu1 from '@/image/icon_renwu1.png';
	export default {
		props: ['params'],
		data() {
			return {
				staticadmin: '',
				icon_renwu,
				icon_renwu1,
				static: false,
				island: 0,
				listdata: []
			}
		},
		watch: {},
		mounted() {
			console.log(this.params);
			var $a = document.getElementById('MsViewid');
			$a.onclick = function(e) {
				e.preventDefault();
				//return false;//也可以
			}
		},
		methods: {
			getdata() {
				this.$ajax({
					method: 'post',
					url: this.$api.bondByRecordsMission,
					data: {}

				}).then(res => {
					if (res.data.qmiscode == 1000) {
						this.listdata = res.data.counts
					}
				})
			},
			//彈出前操作
			moreEvent() {
				this.getdata()
				this.island = this.island ? 0 : 1
			},
			handleClick(val, ind) {
				this.staticadmin = ind
				this.$emit('child', 1)
				this.island = 0
			},
			searchEvent() {
				this.$emit('child', 'back')
				this.island = 0
			},
			handleClick1() {}
		}
	}
</script>

<style land='scss'>
	#MsViewid {
		position: absolute;
		top: 3rem;
		z-index: 100;
		right: 0;
		width: 300px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	.awrptitle {
		font-size: 0.85rem !important;
		padding: .7rem;
		background-color: rgba(244, 244, 244, 1);
		color: rgb(51, 51, 51);
		overflow: hidden;
	}

	.renwufont {
		font-size: 0.85rem !important;
		margin-left: 0.85rem;
		font-weight: bold;
	}

	.hovercolor:hover {
		color: #8763ee !important;
		/* #1890ff */
		cursor: pointer;

	}

	.hovercolor>span:hover {
		color: #8763ee !important;
	}

	.warp_listjqy:hover {
		color: #8763ee !important;
	}
</style>
<style lang="scss" scoped>
	.icon-right {
		position: absolute;
		right: .6rem;
		top: .5rem;
		width: 1rem;
		transform-origin: center center;
		/*设置图片旋转的中心点为左下角*/
		transition: all 0.8s;
		/*设置旋转的过渡效果：所有都过渡 过渡所需时间为0.8秒*/
	}
	.icon-right1 {
		transform: rotate(180deg);
		/*设置当鼠标经过盒子时第一个img的旋转角度为90°*/
	}

	.icon-right0 {
		transform: rotate(0deg);
		/*设置当鼠标经过盒子时第一个img的旋转角度恢复0°*/
	}

	.warp_top {
		transition: height .8s;
		-webkit-transition: height .8s;
		overflow: hidden;
	}

	.gre-title {
		position: relative;
		padding-left: 1.5rem;
	}

	.wil-list {
		position: relative;
		background-color: #fff;
		color: #000;
		padding-left: 3rem;
	}

	.wil-list-tit {
		background-color: #fff;
		color: #000;
		padding-left: 1.5rem;
	}

	.gre-title,
	.wil-list,
	.wil-list-tit {
		height: 2rem;
		line-height: 2rem;
		font-size: .8rem;
	}
</style>
